import React, { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import PositionFilter from '@components/search/positionFilter';
import PositionList from '@components/search/positionList';
import usePositionList from '@components/search/query/usePositionList';
import PositionListFilterVO from '@domain/vo/search/PositionListFilterVO';

import TextFormat from '@utils/text/format';
import classnames from 'classnames/bind';
import styles from './searchPage.module.scss';
const cx = classnames.bind(styles);

interface IPositionListAreaProps {
  keyword: string;
}

const PositionListArea: FC<IPositionListAreaProps> = ({ keyword }) => {
  const methods = useForm<PositionListFilterVO>({
    defaultValues: new PositionListFilterVO(),
  });

  const watchFilter = methods.watch();
  const { data, fetchNextPage } = usePositionList({ ...watchFilter, keyword });
  const viewKeyword = TextFormat.formatEllipsis(keyword, 16);

  return (
    <FormProvider {...methods}>
      <div className={cx('positionListArea')}>
        <strong className={cx('title')}>
          {viewKeyword === '' ? '' : `${viewKeyword}에 대한 `}
          {data?.pages[0].pages.totalElements}개의 포지션 검색 결과입니다.
        </strong>
        <PositionFilter />
        <PositionList keyword={keyword} data={data} onNextPage={fetchNextPage} />
      </div>
    </FormProvider>
  );
};

export default PositionListArea;
